import { createContext } from 'react'

const TranslationContext = createContext(msg => msg)

export default TranslationContext
